import { render, staticRenderFns } from "./DialogWorkspaceAdd.vue?vue&type=template&id=0b954ec0"
import script from "./DialogWorkspaceAdd.vue?vue&type=script&lang=js"
export * from "./DialogWorkspaceAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports